import MobileTableCell from "domains/altCustody/pages/SelectAssetsPage/SelectFund/SelectFundTable/MobileTableCell/MobileTableCell";

export default MobileTableCell;
